'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  domain: '',
  menuToggle: {
    label: 'MENU'
  },
  logo: {
    href: '/'
  },
  mainBtn: [{
    text: 'NOUS CONTACTER',
    classes: 'btn-ghost hidden-xs gold',
    link: ''
  }, {
    text: 'ESPACE CLIENT',
    classes: 'btn-ghost hidden-xs concur-blue',
    link: ''
  }],
  siteLinks: [{
    title: {
      text: 'PRODUITS'
    },
    list: [{
      text: 'Notes de Frais',
      src: '',
      classes: 'sub-menu',
      subMenu: [{
        text: 'Gestion des Notes de Frais',
        src: '/gestion-note-de-frais'
      }, {
        text: 'App Mobile',
        src: '/note-de-frais-mobile'
      }, {
        text: 'Solutions de Paiement',
        src: '/integration-flux-carte'
      }, {
        text: 'Gestion des Budgets',
        src: '/gestion-de-budget'
      }, {
        text: 'Audit des Dépenses',
        src: '/audit-note-de-frais'
      }, {
        text: 'Gestion des Frais Kilométriques',
        src: '/indemnites-kilometriques'
      }, {
        text: 'Ecosystème Partenaires',
        src: '/app-center'
      }]
    }, {
      text: "Voyages d'Affaires",
      src: '',
      classes: 'sub-menu',
      subMenu: [{
        text: "Gestion des Voyages d'Affaires",
        src: '/gestion-deplacements'
      }, {
        text: 'App Mobile',
        src: '/note-de-frais-mobile'
      }, {
        text: 'Connexion Partenaires Voyages',
        src: '/triplink'
      }, {
        text: 'Gestion des Budgets',
        src: '/gestion-de-budget'
      }, {
        text: 'Sécurité des Voyageurs',
        src: '/concur-locate'
      }, {
        text: 'Ecosystème Partenaires',
        src: '/app-center'
      }]
    }, {
      text: 'Entreprise Intelligente',
      src: '',
      classes: 'sub-menu',
      subMenu: [{
        text: 'Intégrations',
        src: '/connecteurs-financiers'
      }, {
        text: 'Analyse & Reporting',
        src: '/analyse-rapport-depense'
      }, {
        text: 'Gestion des Budgets',
        src: '/gestion-de-budget'
      }]
    }, {
      text: 'Support',
      src: '',
      classes: 'sub-menu',
      subMenu: [{
        text: 'Support Administrateur',
        src: '/service-administration'
      }]
    }, {
      text: 'ESSAYER CONCUR EXPENSE',
      src: '/self-guided-demo-expense-fr-fr/',
      classes: 'call-out'
    }, {
      text: 'NOUS CONTACTER',
      src: '/contact',
      classes: 'call-out'
    }]
  }, {
    title: {
      text: 'SOLUTIONS'
    },
    list: [{
      text: 'Pour PME & ETI',
      src: '/pme'
    }, {
      text: 'Pour le Secteur Public',
      src: '/solutions/choix/secteur-public'
    }, {
      text: 'Pour les Responsables Financiers',
      src: '/solution-responsable-financier'
    }, {
      text: 'Pour les Travel Managers',
      src: '/travel-manager'
    }, {
      text: 'Pour les Responsables IT',
      src: '/solution-responsable-IT'
    }, {
      text: 'ASSISTER À UN WEBINAR',
      src: '/frais/deplacements_pros/webinars',
      classes: 'call-out'
    }]
  }, {
    title: {
      text: 'RESSOURCES'
    },
    list: [{
      text: 'Blog',
      src: '/newsroom'
    }, {
      text: 'Médiathèque',
      src: '/mediatheque/index'
    }, {
      text: 'Evénements & Webinars',
      src: '/evenements'
    }, {
      text: 'Témoignages Clients',
      src: '/casestudy'
    }, {
      text: 'FAQ',
      src: '/support'
    }, {
      text: 'NOUS CONTACTER',
      src: '/contact',
      classes: 'call-out'
    }]
  }, {
    title: {
      text: 'À PROPOS'
    },
    list: [{
      text: 'Qui Sommes-Nous ?',
      src: 'a-propos'
    }, {
      text: 'Nos Partenaires',
      src: '/partenaires'
    }, {
      text: 'Nous Rejoindre',
      src: ''
    }, {
      text: 'Politique de Confidentialité',
      src: '/politique-confidentialite'
    }]
  }],
  mobileAppText: {
    text: 'GET CONCUR MOBILE APP'
  }
};